import React, { Component } from "react";
import {Row, Col, container, Table} from "react-bootstrap";
import ReactPlayer from "react-player";
import './audioplay.css';


import ExternalLayout from "../../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../../customComponents/RenderPage/RenderPage";
import Strip from "../../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../../customComponents/SEO/SEOComponent";
import PropTypes from "prop-types";


// import Male Audio Samples
import audiof1 from "../../../assets/sampleDatasets/ChhattFemale/Chhatt_agri_f.wav";
import audiof2 from "../../../assets/sampleDatasets/ChhattFemale/Chhatt_gen_f.wav";
import audiof3 from "../../../assets/sampleDatasets/ChhattFemale/Chhatt_social_f.wav";


function Chhatt_Female(){
    return( 
    <div className="container">
        <table>
            {/* Table Heading */}
            <thead>
            <tr>
                <th className="headTable">Audio</th>
                <th className="headTable">Text</th>
            </tr>
            </thead>
            <tbody>
            <tr> {/* Table Row Sample 1 */}
                <td className="tableEvenRow"><ReactPlayer   
                        url={audiof1}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing ">बाजार म अलगे अलगे फसल लेय बर ओखर बीजहा मिलत रहिथे, किसान मन ह देसी अउ हाईब्रिड फसल अपन जरूरत के हिसाब ले लेथे</p></td>
            </tr>
            <tr> {/* Table Row Sample 2 */}
                    <td className="tableOddRow"><ReactPlayer   
                        url={audiof2}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableOddRow"><p className="p-medium-line-spacing">इंटरनेट प्रोटोकॉल सूट म मूलभूत प्रोटोकॉल ट्रांसमिशन कंट्रोल प्रोटोकॉल, यूजर डेटाग्राम प्रोटोकॉल अउ इंटरनेट प्रोटोकॉल होथे</p></td>
            </tr>
            <tr> {/* Table Row Sample 3 */}
                    <td className="tableEvenRow"><ReactPlayer   
                        url={audiof3}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing">राजनीतिक अर्थबेवस्था म राष्ट्र-राज्य म सीमित मापदंड के भीतर उत्पादन या खपत के अध्ययन करे जाथे </p></td>
            </tr>
            </tbody>
        </table>


    </div>

    );
}

const Sample_Chhatt_Female = (props) => {
    const [width] = useWindowSize();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return(
        <ExternalLayout>
            <RenderPage
                id="tst-landing"
                className={`render px-0 ${props.isClassName ? 'render-page ' : 'min-height-auto'}`}
                containerType="container-fluid"
            > 
                <SEOComponent
                    title="SampleChhattFemale"
                    keywords="Speech Recognition, respin, SPIRE LAB, Navana"
                    description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
                    siteUrl="/SampleChhattFemale" />
                   
                    <Strip
                        id="tst-SampleDatasets"
                        className="strip strip-no-padding px-20"
                        containerType="container"
                    >
                   

                    <div className="mx-0  pt-5">  
                        <h5 className="h5-medium section-title jostRegular title-navy-blue align-left pt-5 pb-5 line-height-48px pl-3"> Sample Chhatt Female Audio</h5>
                            <div className="mx-0 mb-5 pb-5">
                                <Chhatt_Female />
                            </div>
                    </div>

</Strip>
</RenderPage>
</ExternalLayout>
);
};

export default Sample_Chhatt_Female;